import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the #section in the URL (e.g. /#services from a legal page),
// or to the top when moving to a new page.
const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    const isFirstRender = previousPath.current === null;
    const changedPage = previousPath.current !== pathname;
    previousPath.current = pathname;

    // Jump instantly across pages; within the home page let CSS decide
    // (smooth, or instant when the user prefers reduced motion).
    const behavior = changedPage ? "instant" : "auto";

    if (hash) {
      const frame = requestAnimationFrame(() => {
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (target) target.scrollIntoView({ behavior });
      });
      return () => cancelAnimationFrame(frame);
    }

    if (!isFirstRender) {
      window.scrollTo({ top: 0, behavior });
    }
    return undefined;
  }, [pathname, hash, key]);

  return null;
};

export default ScrollManager;
